import { PlanType } from '@dgx-pr-spa/shared/util';
import { planType } from '@shared/helpers/function.helpers';
import { Offer } from '@dgx-pr-spa/shared/util';
import { CurrentPlan } from '@dgx-pr-spa/shared/util';
import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-plan-summary',
  templateUrl: './plan-summary.component.html',
  styleUrls: ['./plan-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanSummaryComponent implements OnInit {
  @Input() currentPlan: CurrentPlan;
  @Input() offer: Offer;
  @Input() upsellEnabled = true;

  message: string;

  ngOnInit() {
    this.message = this.upsellEnabled
      ? planType(this.currentPlan) === PlanType.MULTIPLAN
        ? `Your appliance will continue under your current plan’s cover.`
        : `<strong>This plan has ended</strong>. But don't worry, you'll be covered when you buy a new policy.`
      : `Plan status is currently unavailable.`;

    if (this.offer?.outstanding_dd_amount) {
      this.message += ` You have ${this.offer?.outstanding_dd_count} payments remaining on
      your current plan totalling &pound;${this.offer?.outstanding_dd_amount}.
      This will appear in your payment summary once you’ve chosen a
      replacement.`;
    }
  }
}
